import { useEffect } from 'react';
import { useAuthStore } from '@/store/auth-store';
import { authService } from '@/services/auth-service';

const REFRESH_INTERVAL = 13 * 60 * 1000;

export function useAuthRefresh(): void {
  const isAuthenticated = useAuthStore((s) => s._isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;

    const timer = setInterval(() => {
      authService.refresh().catch(() => {
        console.warn('[AuthRefresh] Token refresh failed');
      });
    }, REFRESH_INTERVAL);

    return () => clearInterval(timer);
  }, [isAuthenticated]);
}
